// import 'primeicons/primeicons.css';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
// import 'primeflex/primeflex.css';
 import "./ind.css";


import React, { Component } from 'react';
import {Sidebar} from 'primereact/sidebar';
import {Button} from 'primereact/button';

class SidebarDemo extends Component {

    constructor() {
        super();
        this.state = {
            visibleLeft: false,
            visibleRight: true,
            visibleTop:false,
            visibleBottom: false,
            visibleFullScreen: false,
            visibleCustomToolbar: false
        };
    }

    render() {
        return (
            <div>
            
                <Sidebar visible={this.state.visibleRight}  className="ui-sidebar-lg" position="right" baseZIndex={0} onHide={() => this.setState({visibleRight: false})} style={{backgroundColor:'#fff',animation: '7s ease-in 5s slidein'}}>
                    <h1 style={{fontWeight:'normal'}}>Right Sidebar</h1>
                    <Button type="button" onClick={(e) => this.setState({visibleRight: false})} label="Save" className="p-button-success" style={{marginRight:'.25em'}} />
                    <Button type="button" onClick={(e) => this.setState({visibleRight: false})} label="Cancel" className="p-button-secondary"/>
                </Sidebar>

            </div>
        )
    }
}
                
export  default SidebarDemo;